export const HOME = {
  emergentLink: "emergent-link",
};

export const TESTIDS = {
  appHeader: "app-header",
  appBrand: "app-brand",
  regionIndicator: "region-indicator",
  searchModeTabs: "search-mode-tabs",
  freeTextInput: "free-text-input",
  cityInput: "city-input",
  categoryInput: "category-input",
  regionSelect: "region-select",
  maxResultsSelect: "max-results-select",
  searchSubmit: "search-submit-button",
  searchClear: "search-clear-button",
  statTotal: "stat-total",
  statLeads: "stat-leads",
  statWithWebsite: "stat-with-website",
  onlyLeadsSwitch: "only-leads-switch",
  tableSearchInput: "table-search-input",
  exportAll: "export-all-button",
  exportLeads: "export-leads-button",
  resultsTable: "results-table",
  loadingState: "loading-state",
  emptyState: "empty-state",
  zeroResults: "zero-results-state",
  searchHistory: "search-history",
};
